import React from 'react';
import Footer from '../components/footer';
import phoneIconError from '../assets/images/phoneIconError.svg';
import '../styling/containerStyles.css'

interface ErrorMessageProps{
    addClass?:string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = (props: ErrorMessageProps) =>{
    const { addClass } = props;
        return (
            addClass === 'app3' ?
                <div className="App">
                    <div className='home popup_logout'>
                        <div className='suc failur-box-wrapper' id="cust box">
                            <div className='failure_transaction validation_failure'>
                                <h2>Your KYC has been rejected. Kindly contact the customer support on&nbsp;
                                    <div className='rightText error customer_care'><a href="tel:18002666662">
                                        <img src={phoneIconError} alt='Phone Icon' className='phoneIcon' />
                                        18002666662</a></div>
                                    &nbsp;or email us at <div className='rightText error customer_care'>
                                        <a href="mailto:fcc@pidilite.com">fcc@pidilite.com</a></div></h2>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div> 
            :
            addClass ?
            <div className="App"> 
            <div className='home popup_logout'>                
                <div className='suc failur-box-wrapper' id="cust box">        
                    <div className='failure_transaction validation_failure'>
                        <h2>Something went wrong please try again.</h2>
                    </div>
                </div>
                <Footer />
            </div>
            </div>
            :
            <div className='home popup_logout'>                
                <div className='suc failur-box-wrapper' id="cust box">        
                    <div className='failure_transaction validation_failure'>
                        <h2>Something went wrong please try again.</h2>
                    </div>
                </div>
                <Footer />
            </div>  
        )
    }

export default ErrorMessage;